import {reportStartCheckout} from "../utility/startCheckout";
import {getClassList} from "../../../Utility/siteConfig";
import React from "react";
import {getCheckoutPath} from "../../services/checkoutHelpers";

export default function PrimaryCheckoutButton({shoppingCart, cartCode}) {
  let checkoutPath = getCheckoutPath({cartCode, shoppingCart})

  const handleClick = (evt) => {
    reportStartCheckout({
      shoppingCart, checkoutType: 'credit_card'
    });
    // return undef so it still follows the href!
  };

  // const common = getClassList({
  //   key: 'CheckoutButton.common',
  //   fallback: CHECKOUT_BUTTON_CLASSES
  // })

  const className = getClassList({
    key: "CheckoutButton.main",
    fallback:
      'btn-primary !text-anti-primary',
    base: [ // block is required because it's an A tag!
      'block w-full py-3 mt-4',
      'uppercase text-lg'
    ]
  })

  // FIXME CARLYLE THEME
  const styles = {
    // boxShadow: '0px 1px 0px darkgreen',
    // borderBottom: '2px solid darkgreen'
  };

  return <a
    style={styles}
    className={className}
    href={checkoutPath} onClick={handleClick}>
    <span className="fa fa-lock mr-2"/>
    {" "}
    Secure Checkout
  </a>
}

